export function formatNoDecimals(number: number | null) {
    return number?.toFixed(0);
}
